<template>
  <div class="kepu-main-container">
    <MyNavBar v-if="!isApp" :title="'我的课程'"/>
    <div style="margin: 16px;text-align: center;font-size: 18px;font-weight: bold;">以下是您的专属科普哦</div>
    <!--    <div style="text-align: center;padding-top: 16px;padding-left:16px;padding-right:16px;font-size: 18px">-->
    <!--      以下是您的专属科普哦-->
    <!--    </div>-->
    <!--    <div style="text-align: center;padding: 16px;font-size: 18px">请多多查看，祝你早日康复</div>-->

    <div v-if="loading" class="loading-text">
      加载中...
    </div>
    <div v-else-if="list" style="padding: 16px;">
      <div v-for="item in list" :key="item.id">
        <div v-if="item.articleModelList" class="kepu-card">
          <div class="title">{{ item.title ? item.title : '科普宣教' }}</div>
          <div class="date">推送日期：{{ item.gmtCreate }}</div>
          <div class="doctor">推送医生：{{ item.doctorName ? item.doctorName : '无' }}</div>
          <div class="description">备注：{{ item.otherDescription ? item.otherDescription : '无备注' }}</div>
          <div class="content-tip">课程内容，请点击下方小方块查看</div>
          <!--          <van-grid :column-num="3">-->
          <!--            <van-grid-item v-for="(c, index) in item.articleModelList" :key="index" class="my-grid-item"-->
          <!--                           @click="showVideo(c)">-->
          <!--              <div style="width: 100%;padding:4px;">{{ c.title }}</div>-->
          <!--            </van-grid-item>-->
          <!--          </van-grid>-->
          <GridText :column-num="3" :itemArray="item.articleModelList" @click="handleItemClick"/>
        </div>
      </div>
    </div>
    <div v-else class="empty-content">
      <div class="empty-icon">📚</div>
      <div>暂无课程内容</div>
    </div>
    <!--  您暂未有专属科普内容，请联系您的护士获取  -->
    <van-popup v-model="showPopup" :style="{ height: '90%' }" position="bottom" @close="closePop" class="video-popup">
      <!--      <van-video :src="videoUrl" :poster="posterUrl" :autoplay="true" :show-center-play="false" :close-on-click-overlay="true" />-->
      <div class="popup-header">
        <span class="popup-title">{{ currentVideo.title }}</span>
      </div>
      <video
        ref="video"
        :src="currentVideo.videoUrl"
        autoplay="autoplay"
        class="play-video"
        controls="controls"
      >
      </video>
      <!--   按钮   -->
      <div class="popup-footer">
        <van-button class="close-btn" type="primary" @click="closePop">关闭</van-button>
      </div>
    </van-popup>
  </div>
</template>

<script>
import MyNavBar from '../../components/MyNavBar'
import KepuDao from '@/h5/doucan/network/KepuDao'
import GridText from '@/h5/doucan/components/GridText.vue'
import ReportFeatureAccessDao from '@/h5/doucan/network/ReportFeatureAccessDao'

export default {
  name: 'MyKepuXuanJiaoMainPage',
  components: {
    GridText,
    MyNavBar
  },
  data () {
    return {
      loading: true,
      list: null,
      currentVideo: '',
      showPopup: false,
      isApp: false,
      patientId: null
    }
  },
  async mounted () {
    const patientId = this.$route.query.patientId
    if (patientId) {
      this.patientId = patientId
    } else {
      this.checkApp()
      if (this.isApp) {
        this.patientId = await window.android.getPatientId()
        console.log('patientId', this.patientId)
      } else {
        this.patientId = this.$store.state.user.profile.userId
      }
    }
    this.reportFeatureAccess()
    await this.load()
  },
  methods: {
    checkApp () {
      const query = this.$route.query
      if (query?.isApp) {
        this.$store.commit('setIsApp', query.isApp)
        this.isApp = query.isApp
      }
      if (this.isApp) {
        // window.getAssessmentData = this.getAssessmentData
        // window.setAssessmentData = this.setAssessmentData
        this.reportBridgeSuccess()
      }
    },
    reportBridgeSuccess () {
      if (!this.isApp) {
        return
      }
      if (window.android && window.android.onBridgeSuccess) {
        var fromAndroid = window.android.onBridgeSuccess('桥接成功 from 入院科普宣教')
        console.log('fromandroid 桥接', fromAndroid)
        console.log('document.visibilityState', document.visibilityState)
        // this.onMounted()
      } else {
        alert(typeof (window.android))
        // this.title = '桥接失败'
      }
    },
    onMounted () {
      // window.android2.onMounted('onMounted')
    },
    async closePop () {
      this.showPopup = false
      this.$refs.video.pause()
    },
    async load () {
      const resp = await KepuDao.loadList(this.patientId)
      console.log('kepu', resp)
      console.log('document.visibilityState', document.visibilityState)
      // 给title添加序号
      for (const item of resp) {
        if (item.articleModelList.length > 0) {
          for (const [index, articleModel] of item.articleModelList.entries()) {
            if (articleModel?.title) {
              articleModel.title = `${index + 1}. ${articleModel.title}`
            }
          }
        }
      }
      this.list = resp
      this.loading = false
    },
    handleItemClick (item) {
      if (item.contentType === 1) {
        this.$router.push({
          path: '/WebPage',
          query: {
            src: item.refLink,
            title: item.title
          }
        })
        return
      }
      if (item.contentType === 2) {
        this.showVideo(item)
      }
    },
    showVideo (video) {
      this.currentVideo = video
      this.showPopup = true
    },
    reportFeatureAccess () {
      ReportFeatureAccessDao.report(13, this.$store.state.user.qrCodeHospital, this.$store.state.user.openId).then(res => {
        console.log('上报访问成功', res)
      })
    }
  }
}
</script>

<style scoped>
.kepu-main-container {
  background: #f7f8fa;
  min-height: 100vh;
  font-family: 'PingFang SC', 'Microsoft YaHei', Arial, sans-serif;
}

.loading-text {
  text-align: center;
  margin-top: 64px;
  color: #888;
  font-size: 18px;
}

.kepu-card {
  background: #fff;
  padding: 20px 16px 16px 16px;
  margin-bottom: 20px;
  border-radius: 12px;
  box-shadow: 0 2px 12px 0 rgba(0,0,0,0.06);
  border: none;
  transition: box-shadow 0.2s;
}
.kepu-card:hover {
  box-shadow: 0 4px 20px 0 rgba(0,0,0,0.10);
}

.title {
  font-size: 20px;
  font-weight: 600;
  margin-bottom: 8px;
  color: #0a4b3d;
  letter-spacing: 1px;
  text-decoration: none !important;
}
.date {
  font-size: 14px;
  color: #8c8c8c;
  margin-bottom: 6px;
}
.doctor {
  font-size: 15px;
  color: #4a4a4a;
  margin-bottom: 6px;
}
.description {
  font-size: 15px;
  color: #4a4a4a;
  margin-bottom: 6px;
}
.content-tip {
  font-size: 15px;
  color: #0c4fa8;
  margin-bottom: 12px;
}

.empty-content {
  background: linear-gradient(135deg, #0a4b3d 60%, #0c4fa8 100%);
  color: #fff;
  font-size: 18px;
  text-align: center;
  height: 180px;
  border-radius: 16px;
  margin-top: 40px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  box-shadow: 0 2px 12px 0 rgba(0,0,0,0.08);
}
.empty-icon {
  font-size: 48px;
  margin-bottom: 12px;
}

.video-popup {
  border-radius: 16px 16px 0 0;
  overflow: hidden;
  background: #fff;
}
.popup-header {
  font-size: 18px;
  text-align: center;
  padding: 18px 0 10px 0;
  border-bottom: 1px solid #f0f0f0;
  background: #f7f8fa;
}
.popup-title {
  font-weight: 600;
  color: #0a4b3d;
}
.play-video {
  width: 100%;
  border-radius: 8px;
  margin: 16px 0 0 0;
  background: #000;
  min-height: 180px;
  max-height: 40vh;
  object-fit: contain;
  display: block;
}
.popup-footer {
  text-align: center;
  padding: 18px 16px 16px 16px;
}
.close-btn {
  width: 100%;
  border-radius: 24px;
  font-size: 16px;
  font-weight: 500;
  letter-spacing: 1px;
}

/* GridText自定义item美化建议：如需进一步美化GridText组件，请在GridText.vue中补充样式 */
</style>
